import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls to the top of the page on every route change.
// Skips when navigating within the same path + search (so hash/anchor links still work).
export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Use 'instant' so it doesn't animate - feels native
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, search]);

  return null;
}
